import Api from '../../services/Api';

const getPedidos = async (idStatusPedido) => {
    const params = { idStatusPedido },
        request = await Api.get('/gestao/pedido', { params }),
        response = request.data;

    return response;
};

const getDataHoraAtual = async () => {
    const request = await Api.get('/gestao/hora-atual'),
        response = request.data,
        { dhAtual } = response;

    return dhAtual;
};

export { getPedidos, getDataHoraAtual };
